import React from "react";
import styles from "./styles/FrequencyPicker.module.css"
import { formatTime } from "../../../Utils/formatTime";

function FrequencyPicker({time_options, OnSelect, disabled, timeContent}) {
    
  return (
        <div onClick={(e)=>e.stopPropagation()} className={styles.main} style={{zIndex:"3" }} >
            {[...new Set(time_options)].map(e=>{
                console.log(e)
                return(
                    <div key={e} onClick={()=>{OnSelect(e)}} className={styles.option_cell}>
                        {formatTime(e, timeContent)}
                    </div>
                )
                })
            }
            
        </div>
  );
}

export default FrequencyPicker;
